import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import ResetPassword from "../components/ResetPassword";

function ResetPasswordPage() {
    return (
        <div>
            <Navbar />
            <ResetPassword />
            <Footer />
        </div>
    )
}

export default ResetPasswordPage;